import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../lib/hooks/languageHooks';
import { strings as Localization } from '../../lib/Localization';
import { useProxyPath } from '../../redux/hook/settingsHooks';

function SearchDealerLink() {
    const language = useLanguage();
    const proxyPath = useProxyPath();

    return (
        <Button
            component={Link}
            variant='contained'
            color='primary'
            to={`${proxyPath}/${language}/static/findRetailers`}
        >
            {Localization.whereCanIBuy}
        </Button>
    )
}

export default SearchDealerLink